"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[445],{

/***/ 9445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CurrencyMenu; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/popover/popover.esm.js
var popover_esm = __webpack_require__(8305);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.esm.js + 3 modules
var transition_esm = __webpack_require__(9196);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/index.js + 230 modules
var esm = __webpack_require__(4653);
// EXTERNAL MODULE: ./contexts/AppContext.tsx + 1 modules
var AppContext = __webpack_require__(8960);
// EXTERNAL MODULE: ./contexts/reducers/curency.reducer.ts
var curency_reducer = __webpack_require__(8077);
;// CONCATENATED MODULE: ./types/enum/currency.ts
var ECurrency;

(function (ECurrency) {
  ECurrency["USD"] = "USD";
  ECurrency["ARS"] = "ARS";
  ECurrency["MXN"] = "MXN";
  ECurrency["COP"] = "COP";
  ECurrency["CLP"] = "CLP";
  ECurrency["UYU"] = "UYU";
  ECurrency["PYG"] = "PYG";
  ECurrency["PEN"] = "PEN";
  ECurrency["CRC"] = "CRC";
  ECurrency["BOB"] = "BOB";
  ECurrency["PAB"] = "PAB";
})(ECurrency || (ECurrency = {}));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(29);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@sentry/nextjs/esm/index.client.js + 69 modules
var index_client = __webpack_require__(26);
;// CONCATENATED MODULE: ./utils/currencies.ts




var CHECKOUT_BFF_URL = "https://bff-sales.digitalhouse.com";
var getAllCurrenciesQuery = "\n  query {\n    getAllCurrencies {\n      alias\n      country {\n        locale\n      }\n    }\n  }\n";
function fetchCurrencies() {
  return _fetchCurrencies.apply(this, arguments);
}

function _fetchCurrencies() {
  _fetchCurrencies = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var response, json;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch(CHECKOUT_BFF_URL, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                query: getAllCurrenciesQuery
              })
            });

          case 3:
            response = _context.sent;
            _context.next = 6;
            return response.json();

          case 6:
            json = _context.sent;
            return _context.abrupt("return", json.data.getAllCurrencies);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);
            // TO DO: implement error handler
            index_client/* captureException */.Tb(_context.t0);
            return _context.abrupt("return", []);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 10]]);
  }));
  return _fetchCurrencies.apply(this, arguments);
}

var getCurrencyFallback = function getCurrencyFallback(currenciesCountries, locale) {
  var _ref, _ref2, _currenciesCountries$;

  var currency = currenciesCountries.find(function (el) {
    return el.country.locale.split('-')[1].toUpperCase() === locale.toUpperCase();
  });
  return (_ref = (_ref2 = currency === null || currency === void 0 ? void 0 : currency.alias) !== null && _ref2 !== void 0 ? _ref2 : (_currenciesCountries$ = currenciesCountries[0]) === null || _currenciesCountries$ === void 0 ? void 0 : _currenciesCountries$.alias) !== null && _ref !== void 0 ? _ref : ECurrency.USD;
};
// EXTERNAL MODULE: ./utils/prefs.ts + 1 modules
var prefs = __webpack_require__(3471);
;// CONCATENATED MODULE: ./hooks/useGetAllCurrencies.ts







function useGetAllCurrencies() {
  var currentCurrency = (0,prefs/* getPref */.N)();

  var _useContext = (0,react.useContext)(AppContext/* AppContext */.I),
      state = _useContext.state,
      dispatch = _useContext.dispatch;

  var _useState = (0,react.useState)(false),
      ready = _useState[0],
      setReady = _useState[1];

  var _useState2 = (0,react.useState)(),
      currency = _useState2[0],
      setCurrency = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      availableCurrencies = _useState3[0],
      setAvailableCurrencies = _useState3[1];

  var _useState4 = (0,react.useState)([]),
      currenciesCountries = _useState4[0],
      setCurrenciesCountries = _useState4[1];

  (0,react.useEffect)(function () {
    var fetchAndSetCurrencies = /*#__PURE__*/function () {
      var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var fetchedCurrenciesCountries, currencies;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetchCurrencies();

              case 2:
                fetchedCurrenciesCountries = _context.sent;

                if (fetchedCurrenciesCountries !== null && fetchedCurrenciesCountries !== void 0 && fetchedCurrenciesCountries.length) {
                  dispatch({
                    type: curency_reducer/* CurrencyActionTypes.setAll */.O.setAll,
                    currencies: fetchedCurrenciesCountries
                  });
                  setCurrenciesCountries(fetchedCurrenciesCountries);
                  currencies = fetchedCurrenciesCountries.map(function (el) {
                    return el.alias;
                  });
                  setAvailableCurrencies(currencies);
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetchAndSetCurrencies() {
        return _ref.apply(this, arguments);
      };
    }();

    if (!(availableCurrencies !== null && availableCurrencies !== void 0 && availableCurrencies.length) && !(currenciesCountries !== null && currenciesCountries !== void 0 && currenciesCountries.length)) {
      fetchAndSetCurrencies();
    }
  }, [availableCurrencies, currenciesCountries, dispatch]);
  (0,react.useEffect)(function () {
    var _state$geoCountry;

    if (availableCurrencies !== null && availableCurrencies !== void 0 && availableCurrencies.length && currenciesCountries !== null && currenciesCountries !== void 0 && currenciesCountries.length && (_state$geoCountry = state.geoCountry) !== null && _state$geoCountry !== void 0 && _state$geoCountry.loc) {
      if (!currentCurrency) {
        var currencyFallback = getCurrencyFallback(currenciesCountries, state.geoCountry.loc);
        setCurrency(currencyFallback);
      } else {
        setCurrency(currentCurrency);
      }
    }
  }, [availableCurrencies, currenciesCountries, state.geoCountry, currentCurrency]);
  (0,react.useEffect)(function () {
    if (currency) {
      dispatch({
        type: curency_reducer/* CurrencyActionTypes.select */.O.select,
        selected: currency
      });
      (0,prefs/* setPref */.n)(currency);
      setTimeout(function () {
        return setReady(true);
      }, 500);
    }
  }, [currency, dispatch]);
  return {
    ready: ready,
    availableCurrencies: availableCurrencies
  };
}
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/CurrencyMenu/svg/ArsFlagSVG.tsx




var ArsFlagSVG = function ArsFlagSVG() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "22",
    height: "22",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M11 22C4.92487 22 -2.65553e-07 17.0751 0 11C2.65553e-07 4.92487 4.92487 -2.65553e-07 11 0C17.0751 2.65553e-07 22 4.92487 22 11C22 17.0751 17.0751 22 11 22Z",
      fill: "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M21.0914 6.6L0.918217 6.6C0.918217 6.6 3.3 -4.28399e-07 11 0C18.7 4.28399e-07 21.0914 6.6 21.0914 6.6Z",
      fill: "#338AF3"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M0.925686 15.4L21.0727 15.4C21.0727 15.4 18.7 22 11 22C3.3 22 0.925686 15.4 0.925686 15.4Z",
      fill: "#338AF3"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M12.2396 7.70526L12.3304 9.4663L14.0553 8.9963L13.074 10.459L14.7653 11.077L13.0867 11.6827L14.0983 13.1527L12.3636 12.6699L12.3092 14.4304L11.181 13.0437L10.0813 14.4222L9.99051 12.6612L8.26565 13.1312L9.24693 11.6685L7.55569 11.0504L9.23426 10.4448L8.22263 8.97478L9.95734 9.45754L10.0117 7.69704L11.14 9.08378L12.2396 7.70526Z",
      fill: "#FFDA44"
    })]
  });
};

/* harmony default export */ var svg_ArsFlagSVG = (ArsFlagSVG);
;// CONCATENATED MODULE: ./components/CurrencyMenu/svg/BobFlagSVG.tsx




var BobFlagSVG = function BobFlagSVG() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "22",
    height: "22",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M11 22.0003C4.92487 22.0003 -2.65552e-07 17.0754 0 11.0003C2.65552e-07 4.92512 4.92487 0.000261102 11 0.000261367C17.0751 0.000261633 22 4.92512 22 11.0003C22 17.0754 17.0751 22.0003 11 22.0003Z",
      fill: "#FFDA44"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M0.511676 14.3262L21.4884 14.3262C20.6184 17.3202 17.2136 22.0219 10.723 22.0006C4.23239 21.9792 0.443172 15.8054 0.511676 14.3262Z",
      fill: "#32AB45"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M21.4884 7.67497L0.511668 7.67497C0.882941 6.28855 3.45854 0.0483503 11 0.000261367C18.5415 -0.0478276 21.3652 6.55465 21.4884 7.67497Z",
      fill: "#D52B1E"
    })]
  });
};

/* harmony default export */ var svg_BobFlagSVG = (BobFlagSVG);
;// CONCATENATED MODULE: ./components/CurrencyMenu/svg/ClpFlagSVG.tsx




var ClpFlagSVG = function ClpFlagSVG() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "22",
    height: "22",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11Z",
      fill: "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M11 11L11 0C4.95 0 0 4.95 0 11H11Z",
      fill: "#0052B4"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M22 11H0C0 17.05 4.95 22 11 22C17.05 22 22 17.05 22 11Z",
      fill: "#D80027"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M6.875 3.3L7.67764 5.77026H10.275L8.17369 7.29697L8.97633 9.76724L6.875 8.24053L4.77367 9.76724L5.5763 7.29697L3.47497 5.77026H6.07236L6.875 3.3Z",
      fill: "white"
    })]
  });
};

/* harmony default export */ var svg_ClpFlagSVG = (ClpFlagSVG);
;// CONCATENATED MODULE: ./components/CurrencyMenu/svg/CopFlagSVG.tsx




var CopFlagSVG = function CopFlagSVG() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "22",
    height: "22",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M22 11.0015C22 17.0758 17.0751 22 11 22C4.92487 22 0 17.0758 0 11.0015C0 4.92724 4.92487 0.00306035 11 0.00306035C17.0751 0.00306035 22 4.92724 22 11.0015Z",
      fill: "#0052B4"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M1.19863 15.9508H20.8246C19.788 17.8756 17.325 22 10.725 22C4.12501 22 1.74863 17.0507 1.19863 15.9508Z",
      fill: "#E92B2B"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M22 11.0015H0C0 5.22736 4.72715 0.153351 10.7249 0.00338686C16.8746 -0.150373 22 4.95239 22 11.0015Z",
      fill: "#FFDA44"
    })]
  });
};

/* harmony default export */ var svg_CopFlagSVG = (CopFlagSVG);
;// CONCATENATED MODULE: ./components/CurrencyMenu/svg/CrcFlagSVG.tsx




var CrcFlagSVG = function CrcFlagSVG() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "22",
    height: "22",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M21.9999 11C21.9999 17.0751 17.0751 21.9999 11 21.9999C4.92485 21.9999 0 17.0751 0 11C0 4.92485 4.92485 0 11 0C17.0751 0 21.9999 4.92485 21.9999 11Z",
      fill: "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M0.692566 7.14997H21.3073C22.2749 9.89996 22.2749 12.375 21.0846 15.3999H0.915293C0.228514 13.6929 0.0136574 12.73 0 11C0.0018053 9.43012 0.274999 8.54486 0.692566 7.14997Z",
      fill: "#D52B1E"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M2.63371 3.85007C3.74854 2.59714 4.81006 1.59382 6.59997 0.825142C8.20637 0.135274 10.1749 0 11 0C11.825 0 13.9871 0.0582279 15.6749 0.825142C17.3826 1.60106 18.4534 2.75534 19.4056 3.85007H2.63371Z",
      fill: "#032B7D"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M19.4054 18.15C18.2906 19.4029 17.2291 20.4062 15.4391 21.1749C13.8328 21.8648 11.8642 22 11.0391 22C10.2141 22 8.05201 21.9418 6.36418 21.1749C4.65654 20.399 3.58572 19.2447 2.63357 18.15L19.4054 18.15Z",
      fill: "#032B7D"
    })]
  });
};

/* harmony default export */ var svg_CrcFlagSVG = (CrcFlagSVG);
;// CONCATENATED MODULE: ./components/CurrencyMenu/svg/MxnFlagSVG.tsx




var MxnFlagSVG = function MxnFlagSVG() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "22",
    height: "22",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11Z",
      fill: "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M15.95 20.9L15.95 1.1C17.325 1.925 22 4.675 22 11.275C22 17.875 17.05 20.35 15.95 20.9Z",
      fill: "#E92B2B"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M6.05 1.1L6.05 20.9C4.675 20.075 3.31127e-07 17.325 1.21336e-07 10.725C2.0004e-07 4.125 4.95 1.65 6.05 1.1Z",
      fill: "#32AB45"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M9.35 8.8L10.175 8.25L10.725 8.8C11.55 8.8 12.0271 9.00215 12.375 9.35C12.925 9.9 12.925 10.3583 12.925 10.725H11.55L12.375 12.1C11.9167 12.1 10.615 11.66 10.175 11C9.735 10.34 9.80833 9.625 9.9 9.35L9.35 8.8Z",
      fill: "#FFBC0E"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.9376 10.4488C8.93694 10.2215 8.75251 10.0375 8.52511 10.0375C8.29729 10.0375 8.11261 10.2222 8.11261 10.45H8.52511C8.11261 10.45 8.11261 10.45 8.11261 10.45L8.11261 10.4509L8.11261 10.4521L8.11263 10.4553L8.11274 10.4645C8.11286 10.472 8.11309 10.4821 8.11351 10.4946C8.11434 10.5196 8.11594 10.5544 8.11903 10.5976C8.12518 10.6837 8.13729 10.8041 8.16119 10.9475C8.20866 11.2323 8.30437 11.6184 8.49991 12.0095C8.69625 12.4022 8.99724 12.8074 9.45645 13.1135C9.91824 13.4214 10.5154 13.6125 11.2751 13.6125C12.0348 13.6125 12.632 13.4214 13.0937 13.1135C13.5529 12.8074 13.8539 12.4021 14.0502 12.0095C14.2457 11.6184 14.3414 11.2323 14.3889 10.9475C14.4128 10.8041 14.4249 10.6837 14.431 10.5975C14.4341 10.5544 14.4357 10.5196 14.4365 10.4946C14.4369 10.4821 14.4372 10.472 14.4373 10.4645L14.4374 10.4552L14.4374 10.4521L14.4374 10.4509C14.4374 10.4509 14.4374 10.45 14.0249 10.45L14.4374 10.45C14.4374 10.2222 14.2527 10.0375 14.0249 10.0375C13.7971 10.0375 13.6124 10.2222 13.6124 10.45M13.6124 10.45L13.6124 10.4513C13.6123 10.4542 13.6122 10.4595 13.612 10.4672C13.6115 10.4824 13.6104 10.5068 13.6081 10.5388C13.6035 10.603 13.5941 10.6975 13.5751 10.8119C13.5366 11.0427 13.4605 11.3441 13.3123 11.6405C13.1649 11.9354 12.9503 12.2176 12.6361 12.4271C12.3245 12.6349 11.8904 12.7875 11.2751 12.7875C10.6598 12.7875 10.2257 12.6349 9.91408 12.4271C9.59985 12.2176 9.38522 11.9353 9.23781 11.6405C9.08959 11.3441 9.01343 11.0427 8.97496 10.8119C8.95589 10.6975 8.94652 10.603 8.94193 10.5388C8.93964 10.5067 8.93856 10.4824 8.93805 10.4671C8.93779 10.4595 8.93768 10.4542 8.93764 10.4512L8.9376 10.4488",
      fill: "#32AB45"
    })]
  });
};

/* harmony default export */ var svg_MxnFlagSVG = (MxnFlagSVG);
;// CONCATENATED MODULE: ./components/CurrencyMenu/svg/PabFlagSVG.tsx




var PabFlagSVG = function PabFlagSVG() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "22",
    height: "22",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11Z",
      fill: "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M11 0C12.4445 -6.31429e-08 13.8749 0.284524 15.2095 0.837325C16.5441 1.39013 17.7567 2.20038 18.7782 3.22183C19.7996 4.24327 20.6099 5.4559 21.1627 6.79048C21.7155 8.12506 22 9.55546 22 11H11L11 0Z",
      fill: "#D52B1E"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M11 22C9.55546 22 8.12506 21.7155 6.79048 21.1627C5.4559 20.6099 4.24327 19.7996 3.22183 18.7782C2.20038 17.7567 1.39013 16.5441 0.837326 15.2095C0.284524 13.8749 -4.59169e-08 12.4445 0 11H11L11 22Z",
      fill: "#032B7D"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M15.5 12L16.2858 14.4184H18.8287L16.7715 15.9131L17.5572 18.3316L15.5 16.8369L13.4428 18.3316L14.2285 15.9131L12.1713 14.4184H14.7142L15.5 12Z",
      fill: "#D52B1E"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M6.5 3L7.2858 5.41844H9.8287L7.77145 6.91312L8.55725 9.33156L6.5 7.83688L4.44275 9.33156L5.22855 6.91312L3.1713 5.41844H5.7142L6.5 3Z",
      fill: "#032B7D"
    })]
  });
};

/* harmony default export */ var svg_PabFlagSVG = (PabFlagSVG);
;// CONCATENATED MODULE: ./components/CurrencyMenu/svg/PenFlagSVG.tsx




/* eslint-disable max-len */
var PenFlagSVG = function PenFlagSVG() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "22",
    height: "22",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11Z",
      fill: "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M15.95 20.9L15.95 1.1C17.325 1.925 22 4.675 22 11.275C22 17.875 17.05 20.35 15.95 20.9Z",
      fill: "#E92B2B"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M6.05 1.1L6.05 20.9C4.675 20.075 -1.13636e-07 17.325 1.21336e-07 10.725C2.0004e-07 4.125 4.95 1.65 6.05 1.1Z",
      fill: "#E92B2B"
    })]
  });
};

/* harmony default export */ var svg_PenFlagSVG = (PenFlagSVG);
;// CONCATENATED MODULE: ./components/CurrencyMenu/svg/PygFlagSVG.tsx




var PygFlagSVG = function PygFlagSVG() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "22",
    height: "22",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M11 22.0003C4.92487 22.0003 -2.65552e-07 17.0754 0 11.0003C2.65552e-07 4.92513 4.92487 0.000261114 11 0.00026138C17.0751 0.000261645 22 4.92513 22 11.0003C22 17.0754 17.0751 22.0003 11 22.0003Z",
      fill: "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M0.511554 14.3258L21.4883 14.3258C20.6182 17.3199 17.2135 22.0216 10.7229 22.0002C4.23227 21.9788 0.443049 15.8051 0.511554 14.3258Z",
      fill: "#0038A8"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M21.4883 7.67464L0.511546 7.67464C0.882819 6.28822 3.45854 0.0483503 11 0.00026138C18.5415 -0.0478275 21.3651 6.55432 21.4883 7.67464Z",
      fill: "#D52B1E"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M11 9.72119L11.2782 10.6174L12.2165 10.605L11.4501 11.1465L11.7518 12.0351L11 11.4735L10.2482 12.0351L10.5499 11.1465L9.78353 10.605L10.7218 10.6174L11 9.72119Z",
      fill: "#FFDA44"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M13.814 11.0003C13.814 12.5544 12.5541 13.8143 11 13.8143C9.4459 13.8143 8.18605 12.5544 8.18605 11.0003C8.18605 9.4462 9.4459 8.18635 11 8.18635C12.5541 8.18635 13.814 9.4462 13.814 11.0003ZM8.59941 11.0003C8.59941 12.3261 9.67419 13.4009 11 13.4009C12.3258 13.4009 13.4006 12.3261 13.4006 11.0003C13.4006 9.6745 12.3258 8.59972 11 8.59972C9.67419 8.59972 8.59941 9.6745 8.59941 11.0003Z",
      fill: "#303030"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M13.1086 11.9246C13.2661 11.5653 13.3292 11.1717 13.2919 10.7812C13.2545 10.3906 13.118 10.0161 12.8953 9.69317C12.6725 9.37022 12.371 9.10954 12.0192 8.93587C11.6674 8.7622 11.2771 8.6813 10.8853 8.70085C10.4935 8.7204 10.1131 8.83974 9.78038 9.04756C9.44763 9.25538 9.17351 9.54478 8.98403 9.88829C8.79454 10.2318 8.69597 10.618 8.69768 11.0103C8.69939 11.4027 8.80132 11.788 8.99379 12.1299C9.1816 12.1898 9.23761 12.1427 9.29044 11.9628C9.12643 11.6715 9.03957 11.3432 9.03811 11.0089C9.03666 10.6746 9.12065 10.3454 9.28212 10.0527C9.44358 9.76 9.67717 9.51339 9.96072 9.3363C10.2443 9.15922 10.5684 9.05752 10.9022 9.04086C11.2361 9.02421 11.5687 9.09314 11.8685 9.24113C12.1682 9.38912 12.4252 9.61126 12.615 9.88645C12.8048 10.1617 12.9211 10.4808 12.953 10.8136C12.9848 11.1464 12.931 11.4817 12.7968 11.7879C12.8704 11.9375 12.9379 11.9691 13.1086 11.9246Z",
      fill: "#303030"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M9.18419 11.0004C9.18419 11.2422 9.23249 11.4816 9.32626 11.7045C9.42003 11.9274 9.55738 12.1293 9.73025 12.2984C9.90311 12.4675 10.108 12.6004 10.3329 12.6892C10.5578 12.7781 10.7982 12.8211 11.04 12.8158C11.2818 12.8105 11.52 12.7569 11.7408 12.6583C11.9616 12.5596 12.1605 12.4179 12.3257 12.2413C12.491 12.0648 12.6193 11.857 12.7032 11.6302C12.7871 11.4034 12.8248 11.1621 12.8142 10.9205C12.7907 10.7445 12.3895 10.7527 12.3976 10.9388C12.4058 11.125 12.3768 11.3108 12.3122 11.4856C12.2475 11.6603 12.1487 11.8204 12.0214 11.9564C11.894 12.0924 11.7408 12.2016 11.5707 12.2776C11.4006 12.3536 11.2171 12.3949 11.0308 12.399C10.8446 12.4031 10.6594 12.3699 10.4861 12.3015C10.3128 12.233 10.155 12.1307 10.0218 12.0004C9.88863 11.8701 9.78281 11.7145 9.71058 11.5428C9.63834 11.3711 9.60112 11.1867 9.60112 11.0004C9.60112 10.814 9.2093 10.7445 9.18419 11.0004Z",
      fill: "#32AB45"
    })]
  });
};

/* harmony default export */ var svg_PygFlagSVG = (PygFlagSVG);
;// CONCATENATED MODULE: ./components/CurrencyMenu/svg/UsdFlagSVG.tsx




var UsdFlagSVG = function UsdFlagSVG() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "22",
    height: "22",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M13.9762 0.412588C13.8176 0.500423 13.6346 0.53414 13.455 0.508615L11.3916 0.316561C11.3225 0.321522 11.2576 0.351292 11.2088 0.400368C11.16 0.449444 11.1307 0.514508 11.1262 0.583519C11.1857 0.849691 11.1597 1.12782 11.052 1.37844C10.9443 1.62906 10.7604 1.83945 10.5262 1.97975L8.79543 3.11094C8.73005 3.17816 8.66275 3.24346 8.66275 3.30299V3.9675C8.65842 4.01699 8.6367 4.06336 8.60153 4.09848C8.56636 4.1336 8.51999 4.15523 8.47044 4.15956H8.40312C8.19294 3.97428 7.99986 3.77053 7.82619 3.55075C7.78921 3.51278 7.74633 3.48101 7.69924 3.45664C7.50254 3.35207 7.27264 3.32863 7.05884 3.39134L6.72615 3.48737C6.49641 3.55235 6.28229 3.6631 6.09655 3.81295C5.91081 3.9628 5.75736 4.14864 5.64545 4.35929L5.46657 4.69154C5.45219 4.72199 5.44423 4.75509 5.44328 4.78874C5.44233 4.8224 5.44839 4.85589 5.46103 4.8871C5.47368 4.91831 5.49269 4.94657 5.51681 4.9701C5.54092 4.99362 5.56968 5.01191 5.60122 5.0238L6.19928 5.21585C6.23711 5.23257 6.26964 5.25929 6.29336 5.29314C6.31709 5.32699 6.33106 5.36668 6.33383 5.40791V5.93989C6.33383 6.05705 6.38581 6.12234 6.48774 6.13195L6.61657 6.15115L6.86653 6.20109C7.0576 6.2397 7.23151 6.33785 7.36317 6.48142C7.49483 6.62499 7.57747 6.80656 7.59924 7.00003C7.60393 7.04938 7.62574 7.09555 7.66083 7.1306C7.69593 7.16565 7.74213 7.18739 7.79154 7.19208H10.9224C10.9572 7.1888 10.9923 7.19292 11.0255 7.20418C11.0586 7.21543 11.089 7.23357 11.1147 7.25739L11.8474 8.05632C11.8729 8.08025 11.9032 8.09844 11.9364 8.10971C11.9696 8.12097 12.0048 8.12503 12.0397 8.12163H12.7723C12.8217 8.12632 12.868 8.14806 12.9031 8.18311C12.9382 8.21816 12.9599 8.26433 12.9646 8.31368V8.78037C12.9622 8.80618 12.9656 8.8322 12.9745 8.85657C12.9833 8.88094 12.9974 8.90308 13.0158 8.9214C13.0341 8.93973 13.0563 8.95381 13.0807 8.96262C13.1051 8.97144 13.1311 8.97478 13.1569 8.97242L14.6204 9.16448C14.6554 9.16674 14.6884 9.18163 14.7131 9.20637C14.7379 9.23111 14.7527 9.264 14.755 9.29891L15.5532 10.6279C15.6869 10.859 15.7405 11.1276 15.7057 11.3923C15.671 11.6569 15.5498 11.9026 15.3608 12.0914L14.8282 12.6906C14.8043 12.7162 14.7861 12.7465 14.7748 12.7796C14.7635 12.8127 14.7594 12.8478 14.7627 12.8826L14.8282 13.0747C14.8957 13.5143 14.8519 13.9638 14.7007 14.3822C14.5496 14.8005 14.2959 15.1744 13.9628 15.4696L12.6974 16.5989C12.4281 16.8295 12.2115 17.1152 12.0622 17.4366C11.9129 17.7579 11.8345 18.1075 11.832 18.4618V19.7255C11.832 19.7735 11.93 20.4553 11.7262 20.849C11.7011 20.8977 11.666 20.9405 11.6231 20.9746C11.5801 21.0086 11.5304 21.0331 11.4772 21.0463C11.4241 21.0596 11.3687 21.0614 11.3148 21.0515C11.2609 21.0417 11.2097 21.0204 11.1646 20.9892C11.0259 20.9132 10.904 20.8099 10.8065 20.6854C10.709 20.5609 10.6379 20.418 10.5974 20.2652C10.4479 19.7338 10.2602 19.2139 10.0358 18.7095C9.92589 18.4862 9.85751 18.2448 9.83388 17.997V14.2059C9.83388 14.1387 9.76653 14.0734 9.69922 14.0138L9.23385 13.7488C8.97075 13.5864 8.76909 13.3414 8.6605 13.0522C8.5519 12.763 8.54259 12.446 8.63392 12.1509L8.70116 12.0184C8.71203 11.9248 8.68815 11.8305 8.63392 11.7534C8.36316 11.4604 8.15944 11.1122 8.0369 10.7328C7.91437 10.3534 7.87587 9.95197 7.92422 9.55626C7.97067 9.1511 8.05239 8.75076 8.16846 8.35977C8.17845 8.26623 8.15465 8.17221 8.10123 8.09474L7.90892 7.90268C7.88774 7.8817 7.86101 7.86706 7.83192 7.86043C7.54325 7.77728 7.27262 7.64117 7.03386 7.45904C6.87546 7.2735 6.67127 7.13249 6.44154 7.04996L6.04537 6.904C5.97807 6.904 5.91081 6.77148 5.91081 6.71195C5.91081 6.59479 5.86081 6.5295 5.75888 6.51989C5.72011 6.51552 5.68158 6.50912 5.64348 6.50069L4.10502 6.11659C3.99205 6.08247 3.88755 6.02503 3.79824 5.94799C3.70893 5.87095 3.63682 5.77604 3.58659 5.66938C3.53637 5.56273 3.50914 5.44673 3.50668 5.3289C3.50423 5.21107 3.52658 5.09403 3.57232 4.98539C3.63963 4.92009 3.5723 4.79333 3.50499 4.72035L2.62806 3.88876C1.08465 5.6973 0.170071 7.95686 0.0214774 10.3285C-0.127116 12.7001 0.498358 15.0559 1.80399 17.0425C3.10962 19.0291 5.02501 20.5393 7.26288 21.3466C9.50076 22.1539 11.9405 22.2148 14.2159 21.5201C16.4914 20.8254 18.4799 19.4125 19.8832 17.4936C21.2865 15.5746 22.029 13.2529 21.9991 10.8768C21.9693 8.50076 21.1689 6.1984 19.7178 4.31515C18.2668 2.4319 16.2434 1.06931 13.9512 0.431795L13.9762 0.412588Z",
      fill: "#EDF2F7"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M3.59731 4.96043C3.55158 5.06908 3.52922 5.18611 3.53168 5.30394C3.53413 5.42177 3.56136 5.53778 3.61158 5.64443C3.66181 5.75108 3.73392 5.846 3.82324 5.92304C3.91255 6.00008 4.01705 6.05752 4.13001 6.09163L5.66847 6.47574C5.70657 6.48416 5.7451 6.49057 5.78387 6.49494C5.8858 6.51031 5.93581 6.5756 5.93581 6.687C5.93581 6.75229 6.00315 6.87905 6.07046 6.87905L6.46662 7.02501C6.69636 7.10753 6.90045 7.24854 7.05885 7.43408C7.29761 7.61621 7.56833 7.75233 7.85701 7.83547C7.8861 7.8421 7.91273 7.85674 7.93391 7.87773L8.12622 8.06978C8.17964 8.14726 8.20353 8.24128 8.19354 8.33481C8.07748 8.7258 7.99575 9.12615 7.94931 9.53131C7.90096 9.92701 7.93936 10.3285 8.0619 10.7079C8.18443 11.0873 8.38816 11.4355 8.65891 11.7284C8.71314 11.8055 8.73712 11.8998 8.72624 11.9934L8.65891 12.126C8.56758 12.421 8.57689 12.7381 8.68549 13.0273C8.79408 13.3165 8.99584 13.5615 9.25894 13.7238L9.72431 13.9889C9.79162 14.0561 9.85887 14.1214 9.85887 14.1809V18.0393C9.8825 18.287 9.95097 18.5284 10.0608 18.7518C10.2853 19.2562 10.4729 19.7761 10.6224 20.3074C10.6628 20.4602 10.734 20.6032 10.8315 20.7277C10.929 20.8521 11.0509 20.9555 11.1896 21.0315C11.2346 21.0627 11.2859 21.0839 11.3398 21.0938C11.3937 21.1036 11.4491 21.1019 11.5023 21.0886C11.5555 21.0753 11.6052 21.0508 11.6481 21.0168C11.6911 20.9828 11.7262 20.94 11.7512 20.8913C11.9551 20.4976 11.857 19.8158 11.857 19.7678V18.5041C11.8595 18.1498 11.938 17.8002 12.0873 17.4788C12.2366 17.1575 12.4531 16.8718 12.7224 16.6411L13.9878 15.5119C14.3209 15.2167 14.5746 14.8428 14.7257 14.4244C14.8769 14.0061 14.9207 13.5566 14.8531 13.117L14.7878 12.9249C14.7845 12.8901 14.7885 12.855 14.7998 12.8219C14.8111 12.7888 14.8293 12.7584 14.8531 12.7328L15.3858 12.1336C15.5748 11.9449 15.6961 11.6991 15.7308 11.4345C15.7656 11.1699 15.7119 10.9012 15.5781 10.6702L14.7801 9.34117C14.7778 9.30626 14.7629 9.27337 14.7381 9.24863C14.7133 9.22389 14.6804 9.209 14.6454 9.20674L13.182 9.01469C13.1562 9.01705 13.1301 9.0137 13.1057 9.00489C13.0813 8.99607 13.0591 8.98199 13.0408 8.96367C13.0224 8.94534 13.0083 8.92321 12.9995 8.89883C12.9906 8.87446 12.9873 8.84844 12.9897 8.82263V8.35594C12.985 8.30659 12.9632 8.26042 12.9281 8.22537C12.893 8.19032 12.8468 8.16857 12.7974 8.16388H12.0647C12.0298 8.16729 11.9946 8.16323 11.9615 8.15197C11.9283 8.14071 11.8979 8.12251 11.8724 8.09859L11.1397 7.29964C11.114 7.27582 11.0836 7.2577 11.0505 7.24644C11.0173 7.23519 10.9822 7.23106 10.9474 7.23434H7.81663C7.76722 7.22965 7.72092 7.20791 7.68583 7.17286C7.65073 7.13781 7.62902 7.09164 7.62432 7.04229C7.60255 6.84883 7.51982 6.66725 7.38816 6.52368C7.2565 6.38011 7.08268 6.28196 6.89162 6.24335L6.64156 6.19342L6.51273 6.17421C6.41081 6.16077 6.35892 6.09547 6.35892 5.98216V5.45017C6.35615 5.40894 6.34208 5.36925 6.31836 5.3354C6.29463 5.30155 6.2621 5.27483 6.22427 5.25812L5.62622 5.06606C5.59468 5.05417 5.56592 5.03588 5.5418 5.01236C5.51768 4.98883 5.49867 4.96057 5.48602 4.92936C5.47338 4.89815 5.46742 4.86466 5.46837 4.83101C5.46932 4.79735 5.47718 4.76426 5.49156 4.73381L5.67044 4.40155C5.78235 4.1909 5.9358 4.00506 6.12154 3.85521C6.30728 3.70536 6.5215 3.59461 6.75124 3.52963L7.08392 3.4336C7.29772 3.37089 7.52754 3.39434 7.72423 3.4989C7.77132 3.52327 7.81421 3.55504 7.85118 3.59301C8.02485 3.81279 8.21793 4.01655 8.42811 4.20182H8.49543C8.54498 4.19749 8.59144 4.17586 8.62661 4.14074C8.66178 4.10562 8.68341 4.05925 8.68774 4.00977V3.2934C8.68774 3.22618 8.75504 3.16089 8.82042 3.10135L10.5512 1.97015C10.7854 1.82985 10.9693 1.61947 11.077 1.36885C11.1847 1.11822 11.2107 0.840094 11.1512 0.573922C11.1557 0.504911 11.185 0.439852 11.2338 0.390777C11.2825 0.341701 11.3475 0.311931 11.4166 0.30697L13.48 0.499024C13.6596 0.524549 13.8426 0.490831 14.0012 0.402997C11.9802 -0.159337 9.84039 -0.132668 7.83409 0.479858C5.8278 1.09238 4.03878 2.26521 2.67812 3.85996L3.55506 4.69155C3.59736 4.76069 3.66462 4.89513 3.59731 4.96043Z",
      fill: "black"
    })]
  });
};

/* harmony default export */ var svg_UsdFlagSVG = (UsdFlagSVG);
;// CONCATENATED MODULE: ./components/CurrencyMenu/svg/UyuFlagSVG.tsx




var UyuFlagSVG = function UyuFlagSVG() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "22",
    height: "22",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M10.9976 22C4.92379 22 -2.65494e-07 17.0762 0 11.0024C2.65494e-07 4.92862 4.92379 0.00483218 10.9976 0.00483244C17.0714 0.00483271 21.9952 4.92862 21.9952 11.0024C21.9952 17.0762 17.0714 22 10.9976 22Z",
      fill: "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M7.20495 2.55606L7.28808 4.16784L8.86675 3.73768L7.96864 5.07639L9.51654 5.64206L7.98023 6.19635L8.90612 7.54179L7.31844 7.09995L7.26866 8.71124L6.23603 7.44203L5.2296 8.70372L5.14646 7.09193L3.5678 7.52209L4.46591 6.18339L2.91801 5.61771L4.45432 5.06342L3.52842 3.71798L5.11611 4.15982L5.16589 2.54853L6.19852 3.81774L7.20495 2.55606Z",
      fill: "#FFDA44"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M11.1606 0.00477383C11.1606 0.00477383 12.8462 -0.113686 15.3966 0.829593C17.3212 1.65447 18.8589 3.30405 18.8589 3.30405H11.1606V0.00477383Z",
      fill: "#338AF3"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M10.9976 5.50362H20.5281C20.5281 5.50362 21.0553 6.48608 21.3035 7.15326C21.5371 7.78113 21.7739 8.8029 21.7739 8.8029H10.9976V5.50362Z",
      fill: "#338AF3"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M0 11.0024L21.9952 11.0024C21.9538 12.5602 21.83 13.409 21.3073 14.8516H0.688223C0.133503 13.4006 0.0197157 12.5648 0 11.0024Z",
      fill: "#338AF3"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M1.81154 17.0511H20.1905C19.052 18.7169 17.9337 19.84 15.7957 20.9002H6.19478C4.94891 20.3504 3.02434 18.9757 1.81154 17.0511Z",
      fill: "#338AF3"
    })]
  });
};

/* harmony default export */ var svg_UyuFlagSVG = (UyuFlagSVG);
;// CONCATENATED MODULE: ./components/CurrencyMenu/svg/WorldSVG.tsx




var WorldSVG = function WorldSVG() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "22",
    height: "22",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M13.9762 0.412588C13.8176 0.500423 13.6346 0.53414 13.455 0.508615L11.3916 0.316561C11.3225 0.321522 11.2576 0.351292 11.2088 0.400368C11.16 0.449444 11.1307 0.514508 11.1262 0.583519C11.1857 0.849691 11.1597 1.12782 11.052 1.37844C10.9443 1.62906 10.7604 1.83945 10.5262 1.97975L8.79543 3.11094C8.73005 3.17816 8.66275 3.24346 8.66275 3.30299V3.9675C8.65842 4.01699 8.6367 4.06336 8.60153 4.09848C8.56636 4.1336 8.51999 4.15523 8.47044 4.15956H8.40312C8.19294 3.97428 7.99986 3.77053 7.82619 3.55075C7.78921 3.51278 7.74633 3.48101 7.69924 3.45664C7.50254 3.35207 7.27264 3.32863 7.05884 3.39134L6.72615 3.48737C6.49641 3.55235 6.28229 3.6631 6.09655 3.81295C5.91081 3.9628 5.75736 4.14864 5.64545 4.35929L5.46657 4.69154C5.45219 4.72199 5.44423 4.75509 5.44328 4.78874C5.44233 4.8224 5.44839 4.85589 5.46103 4.8871C5.47368 4.91831 5.49269 4.94657 5.51681 4.9701C5.54092 4.99362 5.56968 5.01191 5.60122 5.0238L6.19928 5.21585C6.23711 5.23257 6.26964 5.25929 6.29336 5.29314C6.31709 5.32699 6.33106 5.36668 6.33383 5.40791V5.93989C6.33383 6.05705 6.38581 6.12234 6.48774 6.13195L6.61657 6.15115L6.86653 6.20109C7.0576 6.2397 7.23151 6.33785 7.36317 6.48142C7.49483 6.62499 7.57747 6.80656 7.59924 7.00003C7.60393 7.04938 7.62574 7.09555 7.66083 7.1306C7.69593 7.16565 7.74213 7.18739 7.79154 7.19208H10.9224C10.9572 7.1888 10.9923 7.19292 11.0255 7.20418C11.0586 7.21543 11.089 7.23357 11.1147 7.25739L11.8474 8.05632C11.8729 8.08025 11.9032 8.09844 11.9364 8.10971C11.9696 8.12097 12.0048 8.12503 12.0397 8.12163H12.7723C12.8217 8.12632 12.868 8.14806 12.9031 8.18311C12.9382 8.21816 12.9599 8.26433 12.9646 8.31368V8.78037C12.9622 8.80618 12.9656 8.8322 12.9745 8.85657C12.9833 8.88094 12.9974 8.90308 13.0158 8.9214C13.0341 8.93973 13.0563 8.95381 13.0807 8.96262C13.1051 8.97144 13.1311 8.97478 13.1569 8.97242L14.6204 9.16448C14.6554 9.16674 14.6884 9.18163 14.7131 9.20637C14.7379 9.23111 14.7527 9.264 14.755 9.29891L15.5532 10.6279C15.6869 10.859 15.7405 11.1276 15.7057 11.3923C15.671 11.6569 15.5498 11.9026 15.3608 12.0914L14.8282 12.6906C14.8043 12.7162 14.7861 12.7465 14.7748 12.7796C14.7635 12.8127 14.7594 12.8478 14.7627 12.8826L14.8282 13.0747C14.8957 13.5143 14.8519 13.9638 14.7007 14.3822C14.5496 14.8005 14.2959 15.1744 13.9628 15.4696L12.6974 16.5989C12.4281 16.8295 12.2115 17.1152 12.0622 17.4366C11.9129 17.7579 11.8345 18.1075 11.832 18.4618V19.7255C11.832 19.7735 11.93 20.4553 11.7262 20.849C11.7011 20.8977 11.666 20.9405 11.6231 20.9746C11.5801 21.0086 11.5304 21.0331 11.4772 21.0463C11.4241 21.0596 11.3687 21.0614 11.3148 21.0515C11.2609 21.0417 11.2097 21.0204 11.1646 20.9892C11.0259 20.9132 10.904 20.8099 10.8065 20.6854C10.709 20.5609 10.6379 20.418 10.5974 20.2652C10.4479 19.7338 10.2602 19.2139 10.0358 18.7095C9.92589 18.4862 9.85751 18.2448 9.83388 17.997V14.2059C9.83388 14.1387 9.76653 14.0734 9.69922 14.0138L9.23385 13.7488C8.97075 13.5864 8.76909 13.3414 8.6605 13.0522C8.5519 12.763 8.54259 12.446 8.63392 12.1509L8.70116 12.0184C8.71203 11.9248 8.68815 11.8305 8.63392 11.7534C8.36316 11.4604 8.15944 11.1122 8.0369 10.7328C7.91437 10.3534 7.87587 9.95197 7.92422 9.55626C7.97067 9.1511 8.05239 8.75076 8.16846 8.35977C8.17845 8.26623 8.15465 8.17221 8.10123 8.09474L7.90892 7.90268C7.88774 7.8817 7.86101 7.86706 7.83192 7.86043C7.54325 7.77728 7.27262 7.64117 7.03386 7.45904C6.87546 7.2735 6.67127 7.13249 6.44154 7.04996L6.04537 6.904C5.97807 6.904 5.91081 6.77148 5.91081 6.71195C5.91081 6.59479 5.86081 6.5295 5.75888 6.51989C5.72011 6.51552 5.68158 6.50912 5.64348 6.50069L4.10502 6.11659C3.99205 6.08247 3.88755 6.02503 3.79824 5.94799C3.70893 5.87095 3.63682 5.77604 3.58659 5.66938C3.53637 5.56273 3.50914 5.44673 3.50668 5.3289C3.50423 5.21107 3.52658 5.09403 3.57232 4.98539C3.63963 4.92009 3.5723 4.79333 3.50499 4.72035L2.62806 3.88876C1.08465 5.6973 0.170071 7.95686 0.0214774 10.3285C-0.127116 12.7001 0.498358 15.0559 1.80399 17.0425C3.10962 19.0291 5.02501 20.5393 7.26288 21.3466C9.50076 22.1539 11.9405 22.2148 14.2159 21.5201C16.4914 20.8254 18.4799 19.4125 19.8832 17.4936C21.2865 15.5746 22.029 13.2529 21.9991 10.8768C21.9693 8.50076 21.1689 6.1984 19.7178 4.31515C18.2668 2.4319 16.2434 1.06931 13.9512 0.431795L13.9762 0.412588Z",
      fill: "#EDF2F7"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M3.59731 4.96043C3.55158 5.06908 3.52922 5.18611 3.53168 5.30394C3.53413 5.42177 3.56136 5.53778 3.61158 5.64443C3.66181 5.75108 3.73392 5.846 3.82324 5.92304C3.91255 6.00008 4.01705 6.05752 4.13001 6.09163L5.66847 6.47574C5.70657 6.48416 5.7451 6.49057 5.78387 6.49494C5.8858 6.51031 5.93581 6.5756 5.93581 6.687C5.93581 6.75229 6.00315 6.87905 6.07046 6.87905L6.46662 7.02501C6.69636 7.10753 6.90045 7.24854 7.05885 7.43408C7.29761 7.61621 7.56833 7.75233 7.85701 7.83547C7.8861 7.8421 7.91273 7.85674 7.93391 7.87773L8.12622 8.06978C8.17964 8.14726 8.20353 8.24128 8.19354 8.33481C8.07748 8.7258 7.99575 9.12615 7.94931 9.53131C7.90096 9.92701 7.93936 10.3285 8.0619 10.7079C8.18443 11.0873 8.38816 11.4355 8.65891 11.7284C8.71314 11.8055 8.73712 11.8998 8.72624 11.9934L8.65891 12.126C8.56758 12.421 8.57689 12.7381 8.68549 13.0273C8.79408 13.3165 8.99584 13.5615 9.25894 13.7238L9.72431 13.9889C9.79162 14.0561 9.85887 14.1214 9.85887 14.1809V18.0393C9.8825 18.287 9.95097 18.5284 10.0608 18.7518C10.2853 19.2562 10.4729 19.7761 10.6224 20.3074C10.6628 20.4602 10.734 20.6032 10.8315 20.7277C10.929 20.8521 11.0509 20.9555 11.1896 21.0315C11.2346 21.0627 11.2859 21.0839 11.3398 21.0938C11.3937 21.1036 11.4491 21.1019 11.5023 21.0886C11.5555 21.0753 11.6052 21.0508 11.6481 21.0168C11.6911 20.9828 11.7262 20.94 11.7512 20.8913C11.9551 20.4976 11.857 19.8158 11.857 19.7678V18.5041C11.8595 18.1498 11.938 17.8002 12.0873 17.4788C12.2366 17.1575 12.4531 16.8718 12.7224 16.6411L13.9878 15.5119C14.3209 15.2167 14.5746 14.8428 14.7257 14.4244C14.8769 14.0061 14.9207 13.5566 14.8531 13.117L14.7878 12.9249C14.7845 12.8901 14.7885 12.855 14.7998 12.8219C14.8111 12.7888 14.8293 12.7584 14.8531 12.7328L15.3858 12.1336C15.5748 11.9449 15.6961 11.6991 15.7308 11.4345C15.7656 11.1699 15.7119 10.9012 15.5781 10.6702L14.7801 9.34117C14.7778 9.30626 14.7629 9.27337 14.7381 9.24863C14.7133 9.22389 14.6804 9.209 14.6454 9.20674L13.182 9.01469C13.1562 9.01705 13.1301 9.0137 13.1057 9.00489C13.0813 8.99607 13.0591 8.98199 13.0408 8.96367C13.0224 8.94534 13.0083 8.92321 12.9995 8.89883C12.9906 8.87446 12.9873 8.84844 12.9897 8.82263V8.35594C12.985 8.30659 12.9632 8.26042 12.9281 8.22537C12.893 8.19032 12.8468 8.16857 12.7974 8.16388H12.0647C12.0298 8.16729 11.9946 8.16323 11.9615 8.15197C11.9283 8.14071 11.8979 8.12251 11.8724 8.09859L11.1397 7.29964C11.114 7.27582 11.0836 7.2577 11.0505 7.24644C11.0173 7.23519 10.9822 7.23106 10.9474 7.23434H7.81663C7.76722 7.22965 7.72092 7.20791 7.68583 7.17286C7.65073 7.13781 7.62902 7.09164 7.62432 7.04229C7.60255 6.84883 7.51982 6.66725 7.38816 6.52368C7.2565 6.38011 7.08268 6.28196 6.89162 6.24335L6.64156 6.19342L6.51273 6.17421C6.41081 6.16077 6.35892 6.09547 6.35892 5.98216V5.45017C6.35615 5.40894 6.34208 5.36925 6.31836 5.3354C6.29463 5.30155 6.2621 5.27483 6.22427 5.25812L5.62622 5.06606C5.59468 5.05417 5.56592 5.03588 5.5418 5.01236C5.51768 4.98883 5.49867 4.96057 5.48602 4.92936C5.47338 4.89815 5.46742 4.86466 5.46837 4.83101C5.46932 4.79735 5.47718 4.76426 5.49156 4.73381L5.67044 4.40155C5.78235 4.1909 5.9358 4.00506 6.12154 3.85521C6.30728 3.70536 6.5215 3.59461 6.75124 3.52963L7.08392 3.4336C7.29772 3.37089 7.52754 3.39434 7.72423 3.4989C7.77132 3.52327 7.81421 3.55504 7.85118 3.59301C8.02485 3.81279 8.21793 4.01655 8.42811 4.20182H8.49543C8.54498 4.19749 8.59144 4.17586 8.62661 4.14074C8.66178 4.10562 8.68341 4.05925 8.68774 4.00977V3.2934C8.68774 3.22618 8.75504 3.16089 8.82042 3.10135L10.5512 1.97015C10.7854 1.82985 10.9693 1.61947 11.077 1.36885C11.1847 1.11822 11.2107 0.840094 11.1512 0.573922C11.1557 0.504911 11.185 0.439852 11.2338 0.390777C11.2825 0.341701 11.3475 0.311931 11.4166 0.30697L13.48 0.499024C13.6596 0.524549 13.8426 0.490831 14.0012 0.402997C11.9802 -0.159337 9.84039 -0.132668 7.83409 0.479858C5.8278 1.09238 4.03878 2.26521 2.67812 3.85996L3.55506 4.69155C3.59736 4.76069 3.66462 4.89513 3.59731 4.96043Z",
      fill: "black"
    })]
  });
};

/* harmony default export */ var svg_WorldSVG = (WorldSVG);
;// CONCATENATED MODULE: ./components/CurrencyMenu/svg/index.ts












;// CONCATENATED MODULE: ./components/CurrencyMenu/CurrencyMenu.tsx


var _currencyFlagMap;














var currencyFlagMap = (_currencyFlagMap = {}, (0,defineProperty/* default */.Z)(_currencyFlagMap, ECurrency.USD, svg_UsdFlagSVG), (0,defineProperty/* default */.Z)(_currencyFlagMap, ECurrency.ARS, svg_ArsFlagSVG), (0,defineProperty/* default */.Z)(_currencyFlagMap, ECurrency.MXN, svg_MxnFlagSVG), (0,defineProperty/* default */.Z)(_currencyFlagMap, ECurrency.COP, svg_CopFlagSVG), (0,defineProperty/* default */.Z)(_currencyFlagMap, ECurrency.CLP, svg_ClpFlagSVG), (0,defineProperty/* default */.Z)(_currencyFlagMap, ECurrency.UYU, svg_UyuFlagSVG), (0,defineProperty/* default */.Z)(_currencyFlagMap, ECurrency.PYG, svg_PygFlagSVG), (0,defineProperty/* default */.Z)(_currencyFlagMap, ECurrency.PEN, svg_PenFlagSVG), (0,defineProperty/* default */.Z)(_currencyFlagMap, ECurrency.CRC, svg_CrcFlagSVG), (0,defineProperty/* default */.Z)(_currencyFlagMap, ECurrency.BOB, svg_BobFlagSVG), (0,defineProperty/* default */.Z)(_currencyFlagMap, ECurrency.PAB, svg_PabFlagSVG), _currencyFlagMap);
function CurrencyMenu() {
  var _state$currency, _currencyFlagMap$sele;

  var _useContext = (0,react.useContext)(AppContext/* AppContext */.I),
      dispatch = _useContext.dispatch,
      state = _useContext.state;

  var defaultCurrency = state === null || state === void 0 ? void 0 : (_state$currency = state.currency) === null || _state$currency === void 0 ? void 0 : _state$currency.selected;
  var timeoutDuration = 0;
  var buttonRef = (0,react.useRef)(null);

  var _useState = (0,react.useState)(false),
      openState = _useState[0],
      setOpenState = _useState[1];

  var _useState2 = (0,react.useState)(false),
      mobileTouch = _useState2[0],
      setMobileTouch = _useState2[1];

  var _useState3 = (0,react.useState)(defaultCurrency),
      selectedCurrency = _useState3[0],
      setSelectedCurrency = _useState3[1];

  var SelectedFlagComponent = (_currencyFlagMap$sele = currencyFlagMap[selectedCurrency]) !== null && _currencyFlagMap$sele !== void 0 ? _currencyFlagMap$sele : svg_WorldSVG;
  var timeout;

  var _useGetAllCurrencies = useGetAllCurrencies(),
      ready = _useGetAllCurrencies.ready,
      availableCurrencies = _useGetAllCurrencies.availableCurrencies;

  var toggleMenu = function toggleMenu() {
    var _buttonRef$current, _buttonRef$current2;

    setOpenState(function (openStatePrev) {
      return !openStatePrev;
    });
    (_buttonRef$current = buttonRef.current) === null || _buttonRef$current === void 0 ? void 0 : _buttonRef$current.click();
    (_buttonRef$current2 = buttonRef.current) === null || _buttonRef$current2 === void 0 ? void 0 : _buttonRef$current2.blur();
  };

  var onHover = function onHover(open, action) {
    if (mobileTouch) return;

    if (!open && !openState && action === 'onMouseEnter' || open && openState && action === 'onMouseLeave') {
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        return toggleMenu();
      }, timeoutDuration);
    }
  };

  var onMobileTouch = function onMobileTouch(action) {
    if (action === 'onTouchStart') {
      setMobileTouch(true);
    } else if (action === 'onMouseUp') {
      setMobileTouch(false);
    }
  };

  var handleClick = function handleClick(open) {
    setOpenState(!open);
    clearTimeout(timeout);
  };

  var handleCurrencySelect = function handleCurrencySelect(currency) {
    setSelectedCurrency(currency);
    (0,prefs/* setPref */.n)(currency);
    dispatch({
      type: curency_reducer/* CurrencyActionTypes.select */.O.select,
      selected: currency
    });
    toggleMenu();
  };

  (0,react.useEffect)(function () {
    if (state.currency.selected === selectedCurrency) return;
    setSelectedCurrency(state.currency.selected);
  }, [state.currency.selected, selectedCurrency]);
  if (!ready || !(availableCurrencies !== null && availableCurrencies !== void 0 && availableCurrencies.length) || !selectedCurrency) return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {});
  return /*#__PURE__*/(0,jsx_runtime.jsx)(popover_esm/* Popover.Group */.J.Group, {
    as: "div",
    className: "flex space-x-12 flex-none",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(popover_esm/* Popover */.J, {
      className: "relative",
      children: function children(_ref) {
        var open = _ref.open;
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          onMouseEnter: function onMouseEnter() {
            return onHover(open, 'onMouseEnter');
          },
          onMouseLeave: function onMouseLeave() {
            return onHover(open, 'onMouseLeave');
          },
          onTouchStart: function onTouchStart() {
            return onMobileTouch('onTouchStart');
          },
          onMouseUp: function onMouseUp() {
            return onMobileTouch('onMouseUp');
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(popover_esm/* Popover.Button */.J.Button, {
            ref: buttonRef,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: classnames_default()(open ? 'text-gray-900 dark:text-white' : 'text-gray-500 dark:text-gray-300', 'group rounded-md inline-flex items-center text-base', 'font-medium hover:text-gray-900 dark:hover:text-white focus:outline-none', 'focus-visible:ring-2 focus-visible:ring-offset-4 focus-visible:ring-primary-500', 'gap-x-2 cursor-pointer'),
              onClick: function onClick() {
                return handleClick(open);
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SelectedFlagComponent, {}), selectedCurrency, /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* ChevronDownIcon */.v4q, {
                className: classnames_default()(open ? 'text-gray-600 dark:text-white' : 'text-gray-400', 'ml-2 h-5 w-5 group-hover:text-gray-500 dark:group-hover:text-white dark:text-gray-300'),
                "aria-hidden": "true"
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(transition_esm/* Transition */.u, {
            show: open,
            as: react.Fragment,
            enter: "transition ease-out duration-200",
            enterFrom: "opacity-0 translate-y-1",
            enterTo: "opacity-100 translate-y-0",
            leave: "transition ease-in duration-150",
            leaveFrom: "opacity-100 translate-y-0",
            leaveTo: "opacity-0 translate-y-1",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(popover_esm/* Popover.Panel */.J.Panel, {
              className: "absolute z-50 -ml-4 mt-3 transform w-screen sm:max-w-[122px]",
              "static": true,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "rounded-lg bg-[#060606] text-white overflow-hidden",
                style: {
                  boxShadow: '0px 16px 16px 0px rgba(0, 0, 0, 0.08)'
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "relative grid",
                  children: availableCurrencies.map(function (currency) {
                    var _currencyFlagMap$curr;

                    var FlagComponent = (_currencyFlagMap$curr = currencyFlagMap[currency]) !== null && _currencyFlagMap$curr !== void 0 ? _currencyFlagMap$curr : svg_WorldSVG;
                    return /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
                      type: "button",
                      className: classnames_default()('m-0 rounded-none py-3 px-7 flex gap-x-2', 'cursor-pointer text-base hover:bg-[#2C2C31]'),
                      onClick: function onClick() {
                        return handleCurrencySelect(currency);
                      },
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FlagComponent, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        children: currency
                      })]
                    }, currency);
                  })
                })
              })
            })
          })]
        });
      }
    })
  });
}

/***/ })

}]);